import { render, staticRenderFns } from "./GestioneOperazioni.vue?vue&type=template&id=e96ef7d4&"
import script from "./GestioneOperazioni.vue?vue&type=script&lang=js&"
export * from "./GestioneOperazioni.vue?vue&type=script&lang=js&"
import style0 from "./GestioneOperazioni.vue?vue&type=style&index=0&id=e96ef7d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports